/*
  rgd-kit-analytics.js — ponte entre os eventos rgd:kit e o dataLayer.
  A loja ainda não tem GTM: o push só acontece se window.dataLayer existir,
  então instalar o GTM depois passa a alimentar os eventos sem mudar código.
*/
(function () {
  'use strict';

  document.addEventListener('rgd:kit', (event) => {
    const detail = event.detail || {};
    if (!Array.isArray(window.dataLayer)) return;

    window.dataLayer.push({
      event: 'kit_' + (detail.action || 'unknown'),
      kit_slug: detail.kitSlug || null,
      kit_qty: detail.kitQty || 0,
      kit_value: detail.kitValue || 0,
      // Sem isto o tier_reached nao diz QUAL faixa foi atingida.
      kit_tier_pct: detail.tierPct || 0
    });
  });
})();
